// User-specific theme system: presets + custom colours applied via CSS variables.

export const TOKENS = [
  "main_bg", "card_bg", "sidebar_bg", "sidebar_hover", "sidebar_text",
  "border_soft", "text_primary", "text_secondary", "gold", "gold_dark",
  "olive", "olive_dark", "primary", "primary_hover",
  "accent_success", "accent_warning", "accent_danger",
];

// Colours users can tweak directly (label + token)
export const EDITABLE = [
  { key: "main_bg", label: "Background" },
  { key: "card_bg", label: "Cards / Surface" },
  { key: "sidebar_bg", label: "Sidebar" },
  { key: "text_primary", label: "Main Text" },
  { key: "text_secondary", label: "Muted Text" },
  { key: "primary", label: "Accent (Buttons)" },
  { key: "gold", label: "Accent (Text/Icons)" },
  { key: "border_soft", label: "Borders" },
];

export const PRESETS = {
  "light-gold": {
    main_bg: "241 245 249", card_bg: "255 255 255", sidebar_bg: "255 255 255",
    sidebar_hover: "241 245 249", sidebar_text: "71 85 105", border_soft: "226 232 240",
    text_primary: "15 23 42", text_secondary: "100 116 139",
    gold: "184 134 11", gold_dark: "138 102 8", olive: "37 99 235", olive_dark: "29 78 216",
    primary: "234 179 8", primary_hover: "202 154 4",
    accent_success: "22 163 74", accent_warning: "217 119 6", accent_danger: "220 38 38",
  },
  "dark-gold": {
    main_bg: "12 20 15", card_bg: "17 28 22", sidebar_bg: "10 15 12",
    sidebar_hover: "26 43 33", sidebar_text: "156 163 175", border_soft: "42 59 48",
    text_primary: "255 255 255", text_secondary: "156 163 175",
    gold: "212 175 55", gold_dark: "180 145 38", olive: "96 165 250", olive_dark: "59 130 246",
    primary: "212 175 55", primary_hover: "240 200 74",
    accent_success: "34 197 94", accent_warning: "245 158 11", accent_danger: "239 68 68",
  },
  "navy-gold": {
    main_bg: "11 15 26", card_bg: "19 26 38", sidebar_bg: "10 14 23",
    sidebar_hover: "27 36 53", sidebar_text: "148 163 184", border_soft: "36 48 71",
    text_primary: "255 255 255", text_secondary: "148 163 184",
    gold: "250 204 21", gold_dark: "234 179 8", olive: "96 165 250", olive_dark: "59 130 246",
    primary: "250 204 21", primary_hover: "234 179 8",
    accent_success: "34 197 94", accent_warning: "245 158 11", accent_danger: "239 68 68",
  },
};

export const PRESET_LABELS = {
  "light-gold": "Light Gold",
  "dark-gold": "Dark Gold",
  "navy-gold": "Navy Gold",
};

export function applyTheme(vars) {
  if (!vars) return;
  const root = document.documentElement;
  Object.entries(vars).forEach(([k, val]) => root.style.setProperty(`--${k}`, val));
}

export function hexToRgbStr(hex) {
  const m = hex.replace("#", "");
  const r = parseInt(m.substring(0, 2), 16);
  const g = parseInt(m.substring(2, 4), 16);
  const b = parseInt(m.substring(4, 6), 16);
  return `${r} ${g} ${b}`;
}

export function rgbStrToHex(rgb) {
  if (!rgb) return "#000000";
  const [r, g, b] = rgb.split(" ").map((n) => parseInt(n, 10));
  return "#" + [r, g, b].map((x) => x.toString(16).padStart(2, "0")).join("");
}

const KEY = "svt_theme";
export function saveLocal(vars) { try { localStorage.setItem(KEY, JSON.stringify(vars)); } catch (e) {} }
export function loadLocal() { try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; } }
